// Material UI
import { makeStyles } from '@material-ui/core'
import Colors from '../../../constants/Colors'

export default makeStyles({
  labelContainer: {
    color: Colors.SECONDARY_FONT_COLOR,
    fontSize: 13,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    marginBottom: 10,
  },
  rootLabel: {
    color: Colors.DISABLED_COLOR,
    // the name must be exactly the same as the style applied below.
    '&$focusedLabel': {
      color: `${Colors.PRIMARY_COLOR}`,
    },
  },
  // It must be empty. The styles must be applied on root style.
  focusedLabel: {},
  labelOutlined: {
    transform: 'translate(14px, 15px) scale(1)',
  },
  rootInput: {
    // Names depend on the classes that appear on the element that is needed to be modified.
    '& $notchedOutlineInput': {
      borderColor: Colors.DISABLED_COLOR,
    },
    '&:hover $notchedOutlineInput': {
      borderColor: `${Colors.PRIMARY_COLOR}`,
      borderWidth: 2,
      '@media (hover: none)': {},
    },
    '&$focusedInput $notchedOutlineInput': {
      borderWidth: 2,
    },
    '&$disabledInput $notchedOutlineInput': {
      borderColor: `${Colors.DISABLED_COLOR} !important`,
    },
    '&$error $notchedOutlineInput': {
      borderColor: `${Colors.DANGER_COLOR} !important`,
    },
  },
  rootInputHiglighted: {
    // Names depend on the classes that appear on the element that is needed to be modified.
    '& $notchedOutlineInput': {
      borderColor: `${Colors.PRIMARY_COLOR}`,
    },
  },
  /* Styles applied to the root element if the component is focused. */
  focusedInput: {},
  /* Styles applied to the root element if `disabled={true}`. */
  disabledInput: {},
  /* Styles applied to the `NotchedOutline` element. */
  notchedOutlineInput: {},
  /* Styles applied to the `error` element. Don't delete */
  error: {},
  input: {
    color: Colors.PRIMARY_FONT_COLOR,
    fontFamily: 'Poppins',
    fontSize: '0.948em',
    lineHeight: 'normal',
    padding: '14px 10px',
    '&::placeholder': {
      color: Colors.JUMBO,
      fontWeight: 600,
    },
  },
  root: {
    backgroundColor: Colors.WHITE,
    borderRadius: 4,
  },
})
